import React from 'react'

const Card1 = (props) => {
    const data=props.data;
    const navigate=props.navigate;

  return (
    <div className='flex  w-[350px] pb-5 min-h-[300px] flex-col gap-y-2 hover:cursor-pointer hover:scale-105 transition-all duration-700 ' onClick={()=> navigate(`/bookSlot/category/${data.Category}`)}>
        <img src={data.image}  alt='' className='w-full h-[220px] rounded-md'/>

        <div className='text-left font-semibold text-xl'>{data.name}</div>
        <div className='text-left text-sm'>{data.description}</div>
    </div>
  )
}

export default Card1